<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<!-- 搜索框 -->
		<div class="titleView">
			<div style="display: flex;align-items: center;">
				<el-input v-model="keywords" prefix-icon="el-icon-search" placeholder="请输入内容" class="titleInput"
					clearable size="small" @keyup.enter.native="handelSearchClick" />
				<el-button type="button" style="margin-left: 10px;" @click="handelSearchClick" size="small">搜索
				</el-button>
			</div>
			<div style="flex: 1;display: flex;justify-content: flex-end;">
				<el-button class="addClick" @click="handleResetClick" size="small">重置</el-button>
				<el-button type="warning" class="addClick" @click="handleUpdateClick(0)" size="small">新建供应商</el-button>
			</div>
		</div>

		<!-- 表格 -->
		<div class="tableView">
			<el-table :data="tableData" style="width: 100%;">
				<el-table-column prop="basic_info.name" label="简称">
				</el-table-column>
				<el-table-column prop="basic_info.full_name" label="全称">
				</el-table-column>
				<el-table-column prop="basic_info.bank[0].open_account" label="开户银行">
				</el-table-column>
				<el-table-column prop="basic_info.bank[0].bank_no" label="银行账号">
				</el-table-column>
				<el-table-column label="操作" width="160">
					<template slot-scope="scope">
						<el-button @click="handleDoloadClick(scope.row)" type="text" size="small">下载</el-button>
						<el-button @click="handleUpdateClick(1,scope.row)" type="text" size="small">编辑</el-button>
						<el-button type="text" size="small" @click="handleDeleteClick(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<page :page="page.page" :pageSize="page.pageSize" :total="page.total" @change="changePage" style="margin: 10px 0;"></page>
		</div>
		
		<!-- 新增供应商 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogTypeStates" width="30%" :before-close="handleTypeClose">
			<div class="dialogContent">
				<div>简称:</div>
				<el-input v-model="comName" placeholder="请输入供应商简称" size="small"></el-input>
			</div>
			<div class="dialogContent">
				<div>全称:</div>
				<el-input v-model="full_name" placeholder="请输入供应商全称" size="small"></el-input>
			</div>
			<div class="dialogContent">
				<div>开户银行:</div>
				<el-input v-model="open_account" placeholder="请输入开户银行" size="small"></el-input>
			</div>
			<div class="dialogContent">
				<div>银行账号:</div>
				<el-input v-model="bank_no" placeholder="请输入银行账号" size="small"></el-input>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogTypeStates = false" size="small">取 消</el-button>
				<el-button type="warning" @click="handleSubmitClick" size="small">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import axios from 'axios';
	import page from "../../components/page.vue"
	export default {
		components: {
			page
		},
		data() {
			return {
				page: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				keywords: '', //搜索
				fixedHeight: '',
				tableData: [], //表格数据
				dialogTitle:'',
				dialogTypeStates:false,
				comName:'',
				comType:0, //0新建 1编辑
				comData:{},  //更新数据
				full_name:'',
				open_account:'',
				bank_no:''
			}
		},
		mounted() {
			this.fixedHeight = document.documentElement.clientHeight - 76;
			this.getTableData()
		},
		methods: {
			//下载按钮
			handleDoloadClick(row){
				console.log(row)
				axios.get(process.env.VUE_APP_Url4+'api/Procure/UploadSupplierFinalStatement',{
					params:{
						supplier_name:row.basic_info.full_name,
						bank_name:row.basic_info.bank[0].open_account,
						bank_num:row.basic_info.bank[0].bank_no,
					},
					responseType: 'blob'
				}).then(response => {
					// console.log(response)
						var href = window.URL.createObjectURL(response.data); //创建下载的链接
						var downloadElement = document.createElement('a');
						downloadElement.href = href;
						downloadElement.download = '验货单导出.xlsx';
						document.body.appendChild(downloadElement);
						downloadElement.click(); //点击下载
						document.body.removeChild(downloadElement); //下载完成移除元素
						window.URL.revokeObjectURL(href); //释放掉blob对象
				}).catch(err => {
						console.log(err)
				})
			},
			//重置
			handleResetClick(){
				this.keywords = '';
				this.page.page = 1;
				this.handelSearchClick()
			},
			//删除供应商
			handleDeleteClick(row){
				console.log(row)
				this.$confirm('是否删除该供应商?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delete(process.env.VUE_APP_Url2 + `api/Supplier/${row._id}`).then(res => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '已删除'
							});
							this.getTableData();
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});          
				});
			},
			//关闭弹框
			handleTypeClose() {
				this.comName = '';
				this.full_name = '';
				this.open_account = '';
				this.bank_no = '';
				this.dialogTypeStates = false;
			},
			//更新供应商
			handleUpdateClick(type,row){
				console.log(type,row)
				this.comType = type;
				if(type == 0){
					this.comName = '';
					this.full_name = '';
					this.open_account = '';
					this.bank_no = '';
					this.dialogTitle = '新建供应商'
				}else{
					this.dialogTitle = '编辑供应商'
					this.comData = row;
					this.comName = row.basic_info.name;
					this.full_name = row.basic_info.full_name;
					this.open_account = row.basic_info.bank[0].open_account;
					this.bank_no = row.basic_info.bank[0].bank_no;
				}
				this.dialogTypeStates = true;
			},
			//保存
			handleSubmitClick(){
				let params = {}
				if(this.comType == 0){
					params = {
						_id:'',
						basic_info:{
							name:this.comName,
							full_name:this.full_name,
							linker:null,
							taxpayer_no:'',
							bank:[{
								bank_no:this.bank_no,
								open_account:this.open_account
							}],
							address:''
						},
						remark:'',
						shop_info:null,
						operation_info:null
					}
					
				}else{
					let comData = this.comData;
					comData.basic_info.name = this.comName;
					comData.basic_info.full_name = this.full_name;
					comData.basic_info.bank[0].open_account = this.open_account;
					comData.basic_info.bank[0].bank_no = this.bank_no;
					params = comData
				}
				console.log(params)
				this.$http.post(process.env.VUE_APP_Url2 + 'api/Supplier/update', params).then(res => {
					if (res.code == 0) {
						console.log('更新', res)
						if(this.comType == 0){
							this.$message({
								type: 'success',
								message: '已新增'
							});
						}else{
							this.$message({
								type: 'success',
								message: '已修改'
							});
						}
						this.getTableData();
						this.dialogTypeStates = false;
					}
				})
			},
			//搜索
			handelSearchClick() {
				this.page.page = 1;
				this.getTableData()
			},
			// 分页方法
			changePage(num) {
				this.page.page = num;
				this.getTableData();
			},
			//表格
			getTableData() {
				let params = {
					pageIndex: this.page.page,
					pageSize: this.page.pageSize,
					keywords: this.keywords
				}
				this.$http.post(process.env.VUE_APP_Url2 + 'api/Supplier/list', params).then(res => {
					if (res.code == 0) {
						console.log('表格', res)
						this.tableData = res.data.data;
						this.page.total = res.data.count
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.page {
		display: flex;
		flex-direction: column;
	}

	.titleView {
		height: 72px;
		line-height: 72px;
		display: flex;
		background: #fff;
		align-items: center;
		border-radius: 6px;
		margin-bottom: 10px;
		font-size: 12px;
		padding: 0 10px;

		.titleInput {
			width: 130px;
		}

		.titleDate {
			width: 340px;
		}

		.titleSelect {
			width: 100px;
		}
	}

	.flex {
		display: flex;
		align-items: center;
		margin-left: 10px;
	}

	.m-r-10 {
		margin-right: 10px;
		font-size: 12px;
	}

	.tableView {
		padding-bottom: 10px;
		background: #fff;
		flex: 1;
	}
	.dialogContent{
		display: flex;
		align-items: center;
		margin-top: 10px;
		div:nth-of-type(1){
			margin-right: 8px;
			width: 80px;
			font-weight: bold;
			text-align: right;
		}
		div:nth-of-type(2){
			width: 200px;
		}
	}
</style>
